import { OfferedAsType } from '@wix/bookings-uou-types';
export function determinePaymentOptionsBy(pricingPlans, paymentOptions) {
    return [
        ...insertIf(pricingPlans?.length && paymentOptions.wixPaidPlan, OfferedAsType.PRICING_PLAN),
        ...insertIf(isPayable(paymentOptions.wixPayInPerson, paymentOptions.wixPayOnline), OfferedAsType.ONE_TIME),
    ];
}
export function mapServiceOfferedAsDto(serviceResponse) {
    const paymentOptions = serviceResponse.service.paymentOptions;
    return determinePaymentOptionsBy(serviceResponse.pricingPlans, paymentOptions);
}
function insertIf(condition, ...elements) {
    return condition ? elements : [];
}
function isPayable(paidOffline, paidOnline) {
    return paidOffline || paidOnline;
}
//# sourceMappingURL=service-offered-as.mapper.js.map